import script from "./InfoList.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoList.vue?vue&type=script&setup=true&lang=js"

import "./InfoList.vue?vue&type=style&index=0&id=3b40486d&lang=scss&scoped=true"

import exportComponent from "/home/deployer/deploypad/silogues/releases/20261022152544/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b40486d"]])

export default __exports__